import { c as _c } from "react/compiler-runtime";
import { useMiniChips } from "@website/ui/mini-chips/mini-chips.hook";
import styles from "@website/ui/mini-chips/mini-chips.module.scss";
import { MiniChipsPropertiesType } from "@website/ui/mini-chips/mini-chips.types";
import { FC } from "react";
export const MiniChips: FC<MiniChipsPropertiesType> = properties => {
  const $ = _c(19);
  const {
    color,
    EndIcon,
    StartIcon,
    selected,
    size,
    variant,
    text,
    className,
    textClassName,
    children,
    transparent,
    tooltip
  } = properties;
  const {
    endIconProps,
    rootProps
  } = useMiniChips(properties);
  const t0 = `${styles["mini-chips"]} ${styles[variant || "round-accent"]} ${styles[size || "medium"]} ${styles[color || "default"]} ${selected ? styles.selected : ""} ${className ?? ""}`;
  let t1;
  if ($[0] !== color || $[1] !== transparent) {
    t1 = color?.startsWith("#") ? {
      color: transparent ? color : "white",
      backgroundColor: transparent ? `${color}20` : color
    } : {};
    $[0] = color;
    $[1] = transparent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== StartIcon) {
    t2 = StartIcon ? <span className={styles["start-icon"]}>{StartIcon}</span> : null;
    $[3] = StartIcon;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const t3 = textClassName ?? styles.text;
  const t4 = text || children;
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <span className={t3}>{t4}</span>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== EndIcon || $[9] !== endIconProps) {
    t6 = EndIcon ? <span {...endIconProps} className={styles["end-icon"]}>{EndIcon}</span> : null;
    $[8] = EndIcon;
    $[9] = endIconProps;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== rootProps || $[12] !== t0 || $[13] !== t1 || $[14] !== t2 || $[15] !== t5 || $[16] !== t6 || $[17] !== tooltip) {
    t7 = <span {...rootProps} className={t0} style={t1} title={tooltip}>{t2}{t5}{t6}</span>;
    $[11] = rootProps;
    $[12] = t0;
    $[13] = t1;
    $[14] = t2;
    $[15] = t5;
    $[16] = t6;
    $[17] = tooltip;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};